<template>
    <!-- <item-input type="dropdown" :options="select_workbar" v-model="field_active">
    <template v-slot:title="{option}">
      <el-button class="btn_workbar">
        <span><i class="el-icon-menu"></i></span>
        <span v-if="!collapse" class='content'>{{option && option.label}}</span>
      </el-button>
    </template>
  </item-input> -->
    <div>
        <div class="workbar-item" v-for="item in select_workbar" :key="item.value" @click="active(item.id)" :class="{ active: $route.meta.workbar == item.id }">
            <div><text-formatter type="icons" v-model="item.icon" style="font-size: 25px"></text-formatter></div>
            <span style="font-size: 12px">{{ item.name }}</span>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SliderMenu`,
    components: { },
    props: {
        collapse: { type: Boolean, default: false }
    },
    data() {
        return {
            lastVisitPage: {}// 记载每个工作栏下最后访问的菜单项目
        }
    },
    computed: {
        ...mapGetters([`workbar`, `layout/field_active`]),
        select_workbar() {
            return _.orderBy(this.workbar, `display_order`)
        },
        field_active: {
            get: function() {
                return this.$route.meta.workbar // 注册路由时与工作栏绑定
            },
            set: function(newval) {
                let wf = _.find(this.workbar, { id: newval })
                if (wf.first_model) { // 工作栏下是否挂载菜单
                    // todo:跳转到工作栏下最后访问的菜单
                    let route = wf.first_model
                    while (route.children.length > 0) {
                        route = route.children[0]
                    }
                    this.$router.replace(route.fullPath)
                }
            }
        }
    },
    mounted() {
    },
    methods: {
        active(newval) {
            let wf = _.find(this.workbar, { id: newval })
            if (wf.first_model) { // 工作栏下是否挂载菜单
                // todo:跳转到工作栏下最后访问的菜单
                let route = wf.first_model
                while (route.children.length > 0) {
                    route = route.children[0]
                }
                this.$router.replace(route.fullPath)
            }
            // 当菜单列表折叠隐藏时,切换工作栏后 展示出来
            let layout = this.$parent.$parent.$parent
            if (layout && layout.collapse) {
                this.$parent.$parent.$parent.triggerCollapse()
            }
        }
    }
}
</script>
<style scoped lang="less">
.workbar-item {
    padding: 5px;
    color: var(--workbar-text-color, white);
    cursor: pointer;
    &.active {
        background: var(--workbar-active-bg, #254e70);
    }
    &:hover {
        background: var(--workbar-active-bg, #254e70);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Workbar/Index.vue